<template>
  <div>
    <!-- Main Toolbar /  Left SideBar -->
    <appbar />

    <!-- Menu Right -->
    <template>
      <v-navigation-drawer
        v-if="
          !this.$route.path.includes('casino') &&
            !this.$route.path.includes('promotions')
        "
        v-model="drawerRight"
        :width="drawerRightWidth"
        fixed
        right
        app
        touchless
        style="z-index: 205"
      >
        <!-- navigation-drawer era z-index: 205 -->
        <!-- <v-card flat tile>
          <v-toolbar>
            <div class="flex-grow-1"></div>
            <v-toolbar-title>Ao vivo</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-sheet color="black" height="300">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/GIbJY9ff0H4"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-sheet>
        </v-card> -->
        <Coupon
          v-on:expand-coupon="resizeCoupon(drawerRightWidth)"
          v-on:close="drawerRight = false"
        />
      </v-navigation-drawer>
    </template>

    <!-- Content -->
    <v-main>
      <v-container
        :class="{
          'pa-0 c-mobile-table': $vuetify.breakpoint.smAndDown,
          'pa-0 container--fluid': $route.path.includes('casino'),
        }"
      >
        <span
          v-if="$route.path.includes('casino/game')"
          :style="
            `background-image: url('https://dozr8la71aog.cloudfront.net/images/pragmatic/backgrounds/${
              $route.path.split('/')[3]
            }_bg.png');
                background-size: cover;
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-position: center center;
                margin: 0;
                padding: 0;
                display: block;`
          "
        ></span>
        <router-view />
        <footerIns />
        <BtnWhatsapp />
      </v-container>
    </v-main>

    <v-bottom-navigation
      app
      v-if="
        !$route.path.includes('/promotions') &&
          $vuetify.breakpoint.mdAndDown &&
          !$route.path.includes('/myBets/') &&
          !this.$route.path.includes('casino') &&
          depositDialogOpened == false &&
          registerDialogOpened == false
      "
      v-model="activeBtn"
      :input-value="
        $store.state.coupons.length > 0 && $vuetify.breakpoint.mdAndDown
      "
      :style="{
        'z-index': drawerRight ? '' : 203,
        'border-radius': '4px 4px 0 0',
      }"
      :class="
        $store.state.coupons.length > 0
          ? 'primary darken-1'
          : 'colorDominant lighten-1'
      "
    >
      <div class="d-flex flex-grow-1 justify-space-between align-center pl-2">
        <div class="px-2 py-4">
          <div
            class="overline"
            style="
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.4rem !important;
            "
          >
            {{ $t("labelCurrency") }}
          </div>
          {{ bottomNav_bet_amount }}
        </div>
        <div class="px-2 py-4">
          <div
            class="overline"
            style="
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.4rem !important;
            "
          >
            odds
          </div>
          {{ bottomNav_total_odds }}
        </div>
        <div class="px-2 py-4">
          <div
            class="overline"
            style="
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.4rem !important;
            "
          >
            {{ $t("gain") }} ({{ $t("labelCurrency") }})
          </div>
          <span class="font-weight-bold">{{ bottomNav_possible_gain }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-btn @click="drawerRight = !drawerRight" style="opacity: 1 !important">
        <span class="white--text"
          >{{ $store.state.coupons.length }} {{ $t("selection") }}</span
        >
        <v-icon class="white--text">mdi-receipt-text</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<style lang="sass">
#homePage
  .v-item-group.v-bottom-navigation .v-btn .v-btn__content
    opacity: 1 !important
</style>
<script>
import appbar from "@/components/appbar/appbar";
import Coupon from "./coupon";
import footerIns from "@/components/footer/footer";
import getInfoTable from "@/util/infoTable";
import { mapState } from "vuex";
import BtnWhatsapp from "@/components/btn-whatsapp";
export default {
  name: "home",
  components: {
    appbar,
    Coupon,
    footerIns,
    BtnWhatsapp,
  },
  data: () => ({
    activeBtn: 1,
    drawerRight: null,
    drawerRightWidth: 300,
    updateBalanceTimeoutId: 0,
  }),
  mounted() {
    // Reload InfoTable
    const reloadInfoTable = localStorage.getItem("reloadInfoTable");
    const reload = reloadInfoTable === "true";
    if (reload) {
      const isExsit = true;
      getInfoTable(isExsit);
    }
    // Atualiza se não existir as querys da homepage.
    if (
      this.$route.name === "Sports" &&
      !this.$route.query.sport &&
      !this.$route.query.live
    ) {
      this.$router.push("/");
    }
    // defini um valor para bottom navigation
    this.$store.state.lastBetAmount = this.operators.min_stake;

    // PROTEÇÃO DE ROTA DO AGENTE SEM LOGIN
    if (this.$isAgent()) {
      const operator = localStorage.getItem("operator_auth");
      const auth = localStorage.getItem("auth");
      if (auth !== "true") {
        this.$router.push({
          path: `/page/login/auth/${operator}`,
        });
      }
    }

    this.refreshBalance();

    // Mount Ticket Bet for Share
    if (this.$route.query.bet_id) {
      this.createCouponFromBetId(this.$route.query.bet_id);
    }

    if (!this.logged.status && this.$route.query.open_register) {
      this.$store.commit("showDialogRegister", true);
    } else if (localStorage.getItem("forceOpenRegister")) {
      localStorage.setItem("callCampaign", true);
      this.$store.commit("showDialogRegister", true);
    }

    if (this.$route.query.open_confirm_register) {
      this.$store.commit("showDialogConfirmRegister", true);
    }

    if (this.$route.query.open_confirm_email_or_phone_change) {
      this.$store.commit("showDialogPhoneOrEmailChangeConfirmation", true);
    }

    if (this.logged.status && this.$route.query.open_dialog_deposit) {
      this.$store.commit("dialogDeposit", true);
    }
  },
  computed: mapState({
    registerDialogOpened() {
      return this.$store.state.showDialogRegister;
    },
    // Abre o bilhete após a confirmação "ok", do feedback de eventos expirados
    openCouponAfterExpiredEventsFeedback() {
      return this.$store.state.openCouponAfterExpiredEventsFeedback;
    },
    operators() {
      return this.$store.state.operators;
    },
    bottomNav_bet_amount() {
      let val = this.$store.state.lastBetAmount; // recupera o ultimo valor inserido no coupon.
      const { min_stake } = this.operators;
      if (val === "" || val === null) {
        return min_stake;
      }
      return val;
    },
    logged() {
      return this.$store.state.logged;
    },
    bottomNav_total_odds() {
      let total_odds = this.$store.getters.getTotalOddsByCoupons;
      let multi_max = "";

      if (this.$isAgent() && this.logged.status) {
        const { multi_max: multi_max_agent } = this.logged.data;
        multi_max = multi_max_agent;
      } else {
        const { multi_max: multi_max_user } = this.operators;
        multi_max = multi_max_user;
      }

      total_odds = total_odds >= multi_max ? multi_max : total_odds;
      return this.decimalAdjustment(total_odds);
    },
    bottomNav_possible_gain() {
      let possible_gain = this.bottomNav_bet_amount * this.bottomNav_total_odds;
      // const { max_prize } = this.operators;
      // possible_gain = possible_gain >= max_prize ? max_prize : possible_gain;
      let max_prize = "";

      if (this.$isAgent() && this.logged.status) {
        const { max_prize: max_prize_agent } = this.logged.data;
        max_prize = max_prize_agent;
      } else {
        const { max_prize: max_prize_user } = this.operators;
        max_prize = max_prize_user;
      }

      possible_gain = possible_gain >= max_prize ? max_prize : possible_gain;
      return this.decimalAdjustment(possible_gain);
    },
    depositDialogOpened() {
      return this.$store.state.dialogDeposit;
    },
  }),
  watch: {
    $route() {
      if (
        this.$route.query.category &&
        this.$route.name !== "eventsCountries" &&
        this.$route.name !== "BetSuccessCountriesEvent"
      ) {
        this.$store.commit("setCurrentCategory", this.$route.query.category);
      }

      if (!["casinoCategory", "casinoProvider"].includes(this.$route.name)) {
        this.refreshBalance();
      }
    },

    drawerRight: function(val) {
      // Se o SideBar Right for aberto no mobile, adicione a class openSideBarRight no <html>
      if (val && this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.add("openSideBarRight");
        // Registrando a abertura do cupom no analytics;
        this.$gtag.view_cart(this.bottomNav_bet_amount);
      }
      // Se o SideBar Right for fechado no mobile, remova a class openSideBarRight no <html>
      if (!val && this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.remove("openSideBarRight");
      }
    },
    openCouponAfterExpiredEventsFeedback() {
      if (!this.drawerRight) {
        this.drawerRight = true;
      }
    },
  },
  methods: {
    refreshBalance() {
      if (
        !this.$isAgent() &&
        this.$isCreditOnline() &&
        this.$store.state.logged.status
      ) {
        // evita muitas consultas desnecessárias
        if (
          this.$route.path.includes("casino") &&
          this.$route.name !== "casinoLobby"
        ) {
          return;
        }

        clearTimeout(this.updateBalanceTimeoutId);

        this.updateBalanceTimeoutId = setTimeout(() => {
          this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
            this.$store.commit("setCash", resp.data.dados.balance);
            this.$store.commit("setBonus", {
              value: resp.data.dados.balance_bonus,
              status: resp.data.dados.balance_bonus_status,
            });
            this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
            this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
          });
        }, 4000);
      }
    },
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
    resizeCoupon: function(param) {
      param == 300
        ? (this.drawerRightWidth = 600)
        : (this.drawerRightWidth = 300);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    // Set Ticket Bet from Coupon;
    createCouponFromBetId(id_bet) {
      const body = { id_bet, domain: this.$domain() };

      this.$axios
        .post("/player/bets/getBetShare", this.$formdata(body))
        .then((res) => {
          const odds = res.data.dados.odds;

          let validOdds = [];
          let invalidEventNames = [];

          // Reset coupon
          this.$store.commit("setCoupons", []);
          // Handler (Inserindo o Id_odd dentro do data);
          odds.forEach((item) => {
            item.data.id_odd = item.id_odd;

            if (item.data.odds_valid == "1") {
              validOdds.push(item);
            } else {
              const { name_market } = this.$infoTable.markets(
                item.data.id_market
              );
              invalidEventNames.push(`${item.description} - ${name_market}`);
            }
          });

          return { odds: validOdds, invalidEventNames };
        })
        .then(({ odds, invalidEventNames }) => {
          // Inserindo as odds no coupon;
          this.$store.commit("setCoupons", odds);
          // Se for mobile abre cupom;
          // if (this.$vuetify.breakpoint.mobile) {
          //   this.drawerRight = true;
          // }

          // Se tiver algum evento inválido, abre o feedback por cima do cupom
          if (invalidEventNames.length > 0) {
            this.$store.commit("setFeedback", {
              title: this.$t("expiredEvents"),
              msg: this.$t("expiredEventsDetail"),
              type: "warning",
              action: "open_drawer",
              events: invalidEventNames,
              persistent: true,
            });
          } else {
            if (this.$vuetify.breakpoint.mobile) {
              this.drawerRight = true;
            }
          }
        })
        .catch((error) => {
          if (error.response.data.all_odds_invalid) {
            this.$store.commit("setCoupons", []);

            this.$store.commit("setFeedback", {
              title: this.$t("expiredEvents"),
              msg: error.response.data.messages.error,
              type: "error",
            });
          }

          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        });
    },
  },
};
</script>
